import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "Work Order",
    moduleFileType: "signature.png",
  }
];

const workExecutionApis = {
  pendingWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/execution/pending-approvals",
      method: "get",
      params,
    }),
  closedWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/execution/list",
      method: "get",
      params,
    }),
  workExecutionById: (workExeBatchId: any) =>
    makeApiCall({
      url: `/work-order/execution/id/${workExeBatchId}`,
      method: "get",
    }),

  approveWorkExecution: (workExeBatchId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      workExeBatchId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("workExecutionApproval", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/work-order/execution/approve`,
      data: formData,
    });
  },

  rejectWorkExecution: (workExeBatchId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      workExeBatchId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("workOrderEcecutionReject", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/work-order/execution/reject`,
      data: formData,
    });
  },

  listWorkExecution: (params: any) =>
    makeApiCall({
      url: "/work-order/list",
      method: "get",
      params,
    }),
  selfCreateWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/submit-update",
      method: "post",
      data,
    }),
  selfApproveWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/approve",
      method: "post",
      data,
    }),
  selfRejectWorkExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/reject",
      method: "post",
      data,
    }),
  selfPendingWorkExecutionList: (params: any) =>
    makeApiCall({
      url: "/work-order/execution/pending-approvals",
      method: "get",
      params,
    }),
  bulkUploadValidateWorkOrderLines: (data: any) =>
    makeApiCall({
      url: "/work-order/bulkUploadValidateWorkOrderLines",
      method: "post",
      data,
    }),
  holdExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/hold",
      method: "post",
      data,
    }),
  releaseExecution: (data: any) =>
    makeApiCall({
      url: "/work-order/execution/release",
      method: "post",
      data,
    }),
};

export default workExecutionApis;
